import { Component, ViewChild, ComponentFactoryResolver, ViewContainerRef, AfterViewInit, ChangeDetectorRef, Input } from '@angular/core';
import { Events, ModalController } from 'ionic-angular';
import { NavController, NavParams } from 'ionic-angular';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
import { HeaderDetailComponent } from '../../components/header-detail/header-detail'
import { VerticalTabComponent } from '../../components/vertical-tab/vertical-tab';
import { DeskPageServiceProvider } from '../../providers/desk-page-service/desk-page-service';
import { DriveSharePage } from '../../pages/drive-share/drive-share';


declare var epcConnect: any;
@Component({
  selector: 'component-holder',
  templateUrl: 'component-holder.html'
})

export class ComponentHolderComponent implements AfterViewInit {
  @ViewChild('componentHolder', { read: ViewContainerRef, static: false }) componentHolder: ViewContainerRef;
  @ViewChild('versionHistory', { read: ViewContainerRef, static: false }) versionHistory: ViewContainerRef;

  @Input() gridDataRows: any = 0;
  @Input() girdDataAccessType: any;
  @Input() gridTemplateProperty: any;
  @Input() templateName: any;
  @Input() gridParam: any;
  @Input() sourcekey: any;
  @Input() components: any;
  @Input() isShare: boolean = false;

  version_modal: boolean;
  toggleVersion: boolean;
  componentRef: any;
  paramData: any;
  fieldData: any;
  showHeader: boolean = true;
  accessType: any = 'edit';
  ShowHrModule: string;
  codeData: { 'Code': any, 'accessType': any };
  value: any;
  timesheet: any;
  compName: any;
  action: any;
  tabTemplates: any = []
  someProp: any;
  currentGridIdx: any;
  versionHistoryProps: any = [];
  versionHistoryComponentName: any;
  versionHistoryFormGridProps: any = [];
  versionHistoryDefaultFormProps: any = [];
  templateId: any;
  screenProps: any;
  screenPropsVal: any;
  templateGroup: any[];
  templateSummaryGroup: any[];
  pullParams: any;
  formLayoutArr: any[];
  templateProps: any[];
  summaryDataArr: any;
  index: any = 0;
  screen: any;
  resData: any = [];
  currentScreenProps: any;
  broadcastSubs: any;
  constructor(public navCtrl: NavController, public communicationServ: CommunicationServiceProvider, public configApi: ConfigApiServiceProvider, private cdr: ChangeDetectorRef, public Deskservice: DeskPageServiceProvider, public navParams: NavParams, public events: Events, private componentFactoryResolver: ComponentFactoryResolver, public driveService: DriveServiceProvider, private modal: ModalController) {
    this.initDriveEvents();
  }

  initDriveEvents() {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "versionHistory") {
          if (data.event === 'closeVersionHistoryPanel') {
            let flag = data['status'];
            if (flag) {
              this.version_modal = true;
              this.openVersionControl();
            }
          }
        }
        if (data.src === "comp-main") {
          if (data.event === 'getAppComponents') {
            let flag = data['status'];
            let components = data['components']
            if (flag) {
              this.components = components;
            }
          } else if (data.event === 'closeHolder') {
            let flag = data['status'];
            if (flag) {
              this.closeComponentHolder();
            }
          }
        }
      })

    this.events.subscribe("closeRequisitionForm", (status) => {
      if (status) {
        this.closeComponentHolder();
      }
    });

  }

  ngOnInit() {

    if (window.innerWidth > 700) {
      this.screen = "Web";
    } else {
      this.screen = "Mobile";
    }
  }


  ngAfterViewInit() {
    if (this.components) {
      this.initDriveEvents();
      this.gridTemplateRender(this.girdDataAccessType, this.gridTemplateProperty, this.gridParam);
    }
    this.cdr.detectChanges();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  iconShowHeader: boolean = true;

  gridTemplateRender(dataAccessType, templateProperty, param) {
    this.currentGridIdx = this.gridDataRows ? this.gridDataRows.findIndex(ele => ele[this.sourcekey] == param[this.sourcekey]) : 0;
    let arrTemplateProps = [];
    let storeTemplates = this.driveService.storeWrap.storeTemplates;
    templateProperty.forEach(templateProp => {
      if (templateProp != undefined && storeTemplates[templateProp.id] != undefined) {
        arrTemplateProps.push(storeTemplates[templateProp.id]);
      }
    });

    /* * * * * 
    * MOBILE SCREEN 
    * * * * * */
    if (document.getElementById("header") != null) {
      document.getElementById("header").innerText = arrTemplateProps[0].templateName;
    }
    this.accessType = arrTemplateProps[0].accessType;
    this.paramData = param;
    this.codeData = { 'Code': param, 'accessType': this.accessType };
    if (templateProperty.length > 1) {
      let isHDComp = this.getHeaderScreen(arrTemplateProps);
      let component: any;
      let componentName: any;
      if (isHDComp) {
        component = HeaderDetailComponent;
        componentName = 'HeaderDetailComponent';
      } else {
        component = VerticalTabComponent;
        componentName = 'VerticalTabComponent';
        this.iconShowHeader = false;
      }
      this.tabTemplates = arrTemplateProps;
      if (this.componentHolder != undefined) {
        this.componentHolder.clear();
      }
      this.currentScreenProps = templateProperty[0];
      this.driveService.containerComp = componentName;
      let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
      this.componentRef = this.componentHolder.createComponent(componentFactory);
      this.componentRef.instance.tabTemplates = this.tabTemplates;
      this.componentRef.instance.params = param;
      this.componentRef.instance.templateName = this.templateName;
      this.componentRef.instance.accessType = this.accessType;
      this.componentRef.instance.dataAccessType = dataAccessType;
      this.componentRef.instance.components = this.components;
      this.componentRef.instance.containerComp = componentName;
      this.componentRef.instance.tabTemplateName.subscribe((event) => { this.templateName = event; });
      this.codeData = { 'Code': param, 'accessType': this.accessType };
    } else {
      this.currentScreenProps = templateProperty[0];
      var templateName = templateProperty[0].id;
      var componentName = templateProperty[0].componentName;
      if (componentName == 'Form') {
        this.iconShowHeader = true;
      }
      this.accessType = templateProperty[0].accessType;
      this.loadComponent(componentName, param, templateName, dataAccessType);
    }
  }

  /* * * * * * *
  * get header screen
  * * * * * * */
  getHeaderScreen(templates) {
    let header: any;
    templates.forEach((template) => {
      if (template['pluginData']) {
        let pluginData = JSON.parse(template['pluginData']);
        const headerTemp = Object.keys(pluginData).some(plugin => plugin.toLowerCase() === 'header')
        if (headerTemp) {
          header = template;
          localStorage.setItem('headerTemp', JSON.stringify(template));
        }
      }
    });
    return header;
  }

  movPrevRecord() {
    if (!this.gridDataRows) {
      return;
    }
    if (this.versionHistoryComponentName == "Default") {
      this.version_modal = true;
      this.openVersionControl();
    }
    let gridSourcekey = this.gridParam[this.sourcekey];
    let idx = this.gridDataRows.findIndex(ele => ele[this.sourcekey] == gridSourcekey);

    if (idx >= 0) {
      let prevIdx = Number(idx - 1);

      if (prevIdx >= 0) {
        if (this.gridDataRows[prevIdx]) {
          this.gridParam = this.gridDataRows[prevIdx];
          this.gridTemplateRender(this.girdDataAccessType, this.gridTemplateProperty, this.gridParam);
        } else {
          alert("previous data not found");
        }
      } else {
        alert("previous data not found");
      }
    }
  }

  movNextRecord() {
    if (!this.gridDataRows) {
      return;
    }
    if (this.versionHistoryComponentName == "Default") {
      this.version_modal = true;
      this.openVersionControl();
    }
    let sourcekey = this.gridTemplateProperty[0]["sourceKey"]
    let gridSourcekey = this.gridParam[sourcekey];
    let idx = this.gridDataRows.findIndex(ele => ele[sourcekey] == gridSourcekey);

    if (idx >= 0) {
      let nxtIdx = Number(idx + 1);

      if (nxtIdx >= 0) {
        this.gridParam = this.gridDataRows[nxtIdx];
        this.gridTemplateRender(this.girdDataAccessType, this.gridTemplateProperty, this.gridParam);
      } else {
        alert("Next data not found");
      }
    }
  }

  openTemplate(template, param, Tabflag, accessTypeStatus) {
  }

  getComponent(name) {
    for (let i = 0; i < this.components.length; i++) {
      let item = this.components[i];
      if (item.compName === name) {

        return item;
      }
    };
    return null;
  }

  loadComponent(template, param, templateName, dataAccessType) {
    let component = this.getComponent(template);
    if (template.componentName != 'FormGridComponent' && template.componentName != 'SEARCHGRID') {
      this.events.publish('utilizationReport', true, this.configApi.driveApi)
      this.events.publish('tabTrigger', true);
    } else {
      this.events.publish('tabTrigger', true);
    }
    if (!component) {
      component = this.components[0];
      this.versionHistoryComponentName = "Default";
      this.driveService.containerComp = this.versionHistoryComponentName;
      this.driveService.fetchScreenProperties(param, templateName, (screenProps, gridRowData = null) => {
        this.screenProps = screenProps;
        if (this.componentHolder.clear() != undefined) {
          this.componentHolder.clear();
        }
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
        if (!componentFactory) {
          componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
        }
        this.componentRef = this.componentHolder.createComponent(componentFactory);
        this.componentRef.instance.params = param;
        this.componentRef.instance.templateName = templateName;
        this.componentRef.instance.accessType = this.accessType;
        this.componentRef.instance.dataAccessType = dataAccessType;
        this.componentRef.instance.screenProps = screenProps;
        this.componentRef.instance.components = this.components;
        this.componentRef.instance.gridRowData = gridRowData;

      });
    } else {
      if (this.componentHolder.clear() != undefined) {
        this.componentHolder.clear();
      }
      let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
      if (!componentFactory) {
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
      }
      this.driveService.fetchScreenProperties(param, templateName, (screenProps, gridRowData = null) => {
        let sourceKey: any;
        let templateProperty: any = this.driveService.storeWrap.storeTemplates[templateName];
        if (this.driveService.objCurrentFolder.template.length > 1) {
          sourceKey = this.driveService.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id].sourceKey;
        } else {
          sourceKey = templateProperty.sourceKey;
        }
        let parentScreenParam = { [sourceKey]: param[sourceKey] };
        this.componentRef = this.componentHolder.createComponent(componentFactory);
        this.componentRef.instance.params = parentScreenParam;
        this.componentRef.instance.gridParams = param;
        this.componentRef.instance.templateName = templateName;
        this.componentRef.instance.accessType = this.accessType;
        this.componentRef.instance.components = this.components;
        this.componentRef.instance.screenProps = screenProps;
        this.componentRef.instance.gridRowData = gridRowData;
        this.componentRef.instance.appIcon = this.configApi.currentDriveApp.app_icon;
        this.componentRef.instance.appDescription = this.configApi.currentDriveApp.app_description;
        this.componentRef.instance.configApiParams = this.configApi.driveApi;
        this.componentRef.instance.currentDriveApp = this.configApi.currentDriveApp.app_code;
        this.componentRef.instance.currentUserId = this.configApi.configureService.getLoginUserID();
        this.componentRef.instance.UserDetails = this.driveService.LoginUserDetails;
        if (component["compName"] == 'UtilizationReportsComponent') {
          this.componentRef.instance.DeskServicePost.subscribe(val => { this.DeskServicePost(val); });
          this.componentRef.instance.headerSectiondatas.subscribe(val => { this.headerSectiondatas(val); });
          this.componentRef.instance.DeskServicePostadd.subscribe(val => { this.DeskServicePostadd(val); });
          this.componentRef.instance.PullStaffSummaryData.subscribe(val => { this.PullStaffSummaryData(val); });
          this.spComponents();
        }
      })

      if (template.componentName != 'FormGridComponent' && template.componentName != 'SEARCHGRID') {
        this.formLayoutArr = [];
        this.templateProps = [];
        this.index = 0;
        let screenProps = this.driveService.storeWrap.storeTemplates[templateName];
        this.templateGroup = this.getTemplateGroup(screenProps);
        this.pullParams = this.getPullParams(screenProps, param);
        this.configApi.pullSummaryListRequest(this.pullParams, (summaryResponse) => {
          this.summaryDataArr = summaryResponse;
          this.getFormLayout(param, (formLayoutArr) => {
            console.log("formLayoutArr", formLayoutArr);
            this.driveService.setMutiTemplateFormData(this.formLayoutArr, (formObj) => {
              this.driveService.getFormFieldsData(this.formLayoutArr, (formFields) => {
                var multiTemplateProps = Object.assign({}, { "templateGroup": this.templateGroup, "templateSummaryGroup": this.templateSummaryGroup, "pullParams": this.pullParams, "summaryDataArr": this.summaryDataArr, "formLayoutArr": this.formLayoutArr, "templateProps": this.templateProps, "formObj": formObj, "formFields": formFields });
                this.events.publish('tabTriggerDataToCustomApplication', true, screenProps, param, this.accessType, multiTemplateProps);
              });
            });
          });
        });

      } else {
        this.driveService.fetchScreenProperties(param, template.id, (screenProps, gridRowData = null) => {
          this.driveService.broadcastInfo({ src: 'form-grid', event: 'tabTriggerDataToGridApplication', status: true, screenProps: screenProps.id, parentScreenParam: param, accessType: this.accessType, components: this.components, gridRowData: gridRowData, rowDataStatus: true });
        });
      }
    }
  }

  DeskServicePost(data) {
    this.Deskservice.postData(data).then((result) => {
      var resData = JSON.parse(result["_POST_SummaryMethodResult"]);
      this.events.publish('tableConstruction', true, resData);
    });

  }

  DeskServicePostadd(data) {
    this.Deskservice.postData(data).then((result) => {
      var resData = JSON.parse(result["_POST_SummaryMethodResult"]);
      this.events.publish('createChartForm', true, resData);
    });
  }

  PullStaffSummaryData(data) {
    this.configApi.pullSummaryListRequest(data, (summaryResponse) => {
      this.events.publish('summaryListResponse', true, summaryResponse);
    })
  }

  headerSectiondatas(data) {
    this.Deskservice.postData(data).then((result) => {
      var resData = JSON.parse(result["_POST_SummaryMethodResult"]);
      this.events.publish('headerSectionData', true, resData);
    });
  }
  /* * * * * *
  * get FormLayout properties for multiple template
  * * * * * */
  startFetchLayout(parentScreenParam, cbck) {
    let templateID = this.templateGroup[this.index]
    var rowData = this.summaryDataArr[this.index];
    if (rowData.length > 0) {
      rowData = rowData[0];
    } else {
      rowData = {};
    }
    console.log("rowData", rowData);
    this.driveService.fetchTemplateProperties(parentScreenParam, rowData, templateID, (templatePops) => {
      this.templateProps.push(templatePops);
      this.formLayoutArr.push(templatePops['formLayout']);
      this.index++;
      this.getFormLayout(parentScreenParam, cbck);
    });
  }

  /* * * * * *
  * get FormLayout properties for multiple template
  * * * * * */
  getFormLayout(parentScreenParam, cbck) {
    let len = this.templateGroup.length - 1;
    if (this.index > len) {
      cbck(this.formLayoutArr);
    } else {
      this.startFetchLayout(parentScreenParam, cbck)
    }
  }

  /* * * * * *
  * get template data
  * * * * * */
  getPullParams(screenProps, parentScreenParam) {
    var templatePops;
    this.pullParams = Object.assign({}, screenProps.fieldParams, { "PushArray": [] });
    this.templateGroup.forEach((templateID) => {
      templatePops = this.driveService.storeWrap.storeTemplates[templateID];
      var obj = {};
      if (templateID === 'main_empcommunicationdetails600') {
        obj = Object.assign({}, templatePops.pullParams, parentScreenParam, { "addresstype": 6, "apiType": "Summary" });
      } else {
        obj = Object.assign({}, templatePops.pullParams, parentScreenParam, { "apiType": "Summary" });
      }
      this.pullParams['PushArray'].push(obj);
    });
    return this.pullParams;
  }

  /* * * * * *
  * get template group data
  * * * * * */
  getTemplateGroup(template) {
    console.log("getTemplateGroup");
    this.events.publish('utilizationReport', true, this.configApi.driveApi)
    this.templateGroup = [];
    if (template['pluginData']) {
      let pluginData = JSON.parse(template['pluginData'])
      if (pluginData['templateGroup']) {
        this.templateGroup = pluginData['templateGroup'];
      } if (pluginData['templateSummaryGroup']) {
        this.templateSummaryGroup = pluginData['templateSummaryGroup'];
      }
    }
    return this.templateGroup;

  }

  openVersionControl = () => {
    this.version_modal = !this.version_modal;
    let editor_elem = document.getElementById("holder-toggle")
    let elem = document.getElementById("version-toggle")
    if (!this.version_modal) {
      editor_elem.style.width = "99%"
      elem.style.display = "none";
      this.toggleVersion = false;
      var versionHistroryStatus = 'close'
      this.driveService.broadcastInfo({ src: 'grid-main', event: 'versionHistroryStatus', status: versionHistroryStatus });
    } else {
      if (window.innerWidth > 981) {
        editor_elem.style.width = "80%"
      } else {
        editor_elem.style.width = "65%"
      }
      elem.style.display = "block";
      this.toggleVersion = true;
      this.timesheet = false;
      var versionHistroryStatus = 'open'
      this.driveService.broadcastInfo({ src: 'grid-main', event: 'versionHistroryStatus', status: versionHistroryStatus });
    }
    if (this.versionHistoryComponentName == "FormGrid") {
      this.driveService.broadcastInfo({ src: 'versionProps', event: 'toggleVersion', status: this.toggleVersion, versionHistoryProps: this.versionHistoryFormGridProps });
    } else if (this.versionHistoryComponentName == "Custom") {
      this.driveService.broadcastInfo({ src: 'versionProps', event: 'toggleVersion', status: this.toggleVersion, versionHistoryProps: this.versionHistoryProps });
    } else if (this.versionHistoryComponentName == "Default") {
      let parentScreenParam = {};
      parentScreenParam[this.screenProps['sourceKey']] = this.paramData[this.screenProps['sourceKey']];
      this.templateId = this.screenProps.id
      this.versionHistoryDefaultFormProps = { "templateProps": this.templateId, "paramsData": parentScreenParam };
      this.driveService.broadcastInfo({ src: 'versionProps', event: 'toggleVersion', status: this.toggleVersion, versionHistoryProps: this.versionHistoryDefaultFormProps });

    }
  }

  closeComponentHolder() {
    this.driveService.formGridTempProps = {};
    this.driveService.gridNewForm = false;
    if (this.isShare == true) {
      window.close();
    } else {
      epcConnect.destoryCKEditor = false;
      /* * * * * * *
      * on close clear Grid config
      * * * * * * */
      epcConnect.loadGridTemplate = false;
      epcConnect.colProps = {};
      epcConnect.rowData = {};
      epcConnect.screenProps = {};
      this.driveService.broadcastInfo({ src: 'drive-main', event: 'showComponentHolder', status: false });
      this.driveService.broadcastInfo({ src: 'main', event: 'headerShow', data: true });
      this.driveService.broadcastInfo({ src: 'sidePanelShow', event: 'sideBarShow', status: true });
    }
  }


  spComponents() {
    this.events.publish('utilizationReport', true, this.configApi.driveApi);
  }

  shareFile(e) {
    let selectedFile = [];
    selectedFile.push(this.paramData);
    var folderProperty;
    var templateInfo;
    var selectedRow = [];
    this.driveService.objCurrentFolder['files'] = [];
    let formGridTemplate: any = [];
    if (this.currentScreenProps.componentName === 'FormGridComponent' || this.currentScreenProps.componentName === "SUMMARY") {
      formGridTemplate.push({ 'id': this.currentScreenProps['id'], 'filterParams': this.currentScreenProps.filterParams });
      folderProperty = {
        'template': formGridTemplate
      }
      templateInfo = formGridTemplate;
    } else {
      folderProperty = {
        'template': this.driveService.objCurrentFolder.template
      }
      templateInfo = this.driveService.objCurrentFolder.template;
    }
    selectedRow.push({ [this.driveService.storeWrap.storeTemplates[templateInfo[0].id].sourceKey]: selectedFile[0][this.driveService.storeWrap.storeTemplates[templateInfo[0].id].sourceKey] });


    let data = Object.assign({}, this.configApi.driveApi.pushLinkShareUser.params, {
      "RecordID": selectedFile[0][this.currentScreenProps.sourceKey],
      "ShareID": '',
      "ShareType": 'File',
      "TemplateID": this.currentScreenProps.id,
      "TemplateName": this.currentScreenProps.templateName,
      "userid": this.driveService.configureService.getLoginUserID(),
      "SharedInfo": { 'rowData': selectedFile, 'sharedFolder': folderProperty, 'senderId': this.driveService.configureService.getLoginData()['user'], 'accessType': 'public', 'pullFolderTemplate': { "client": this.driveService.configureService.getStudio(), 'userid': this.driveService.configureService.getLoginUserID(), 'app_code': this.configApi.currentDriveApp['app_code'], 'currentAppDetails': this.configApi.currentDriveApp, "LoginUserDetails": this.driveService.LoginUserDetails } }

    });
    var modalPage = this.modal.create(DriveSharePage, { 'shareDataSet': data, "ShareType": 'File', 'ShareID': '', 'currentFolderTemplate': this.currentScreenProps['templateName'], 'selectedRowData': selectedFile }, { cssClass: "data_Share", showBackdrop: true, enableBackdropDismiss: false });
    modalPage.present();
    modalPage.onDidDismiss(data => {

    });
  }

  ngOnDestroy() {
  }

}



// WEBPACK FOOTER //
// ./src/components/component-holder/component-holder.ts